module.exports = __webpack_public_path__ + "media/sound.d3fb31fc.wav";